/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination } from '../models/Pagination';
import type { Position } from '../models/Position';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PositionsService {

    /**
     * Export position questions
     * Returns every position on the account that has its own questions, with those questions. Compatible with POST /internal_api/positions/{id}/questions/import.
     * @param xAccessToken
     * @returns any OK
     * @throws ApiError
     */
    public static getInternalApiPositionsQuestionsExport(
        xAccessToken: string,
    ): CancelablePromise<{
        positions?: Array<{
            id?: string;
            name?: string;
            data_fields?: Array<any>;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/positions/questions/export',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Import position questions
     * Gives the position the exported questions. A position that already has questions keeps them, so a re-run never duplicates them.
     * @param id External ID of the target position
     * @param xAccessToken
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postInternalApiPositionsQuestionsImport(
        id: string,
        xAccessToken: string,
        requestBody: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/positions/{id}/questions/import',
            path: {
                'id': id,
            },
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * index
     * Returns positions
     * @param query Filter positions by name
     * @param page The page of results to view
     * @param perPage The number of results to return per page
     * @returns any success
     * @throws ApiError
     */
    public static getInternalApiPositions(
        query?: string,
        page?: number,
        perPage?: number,
    ): CancelablePromise<{
        positions: Array<Position>;
        pagination?: Pagination;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/positions',
            query: {
                'query': query,
                'page': page,
                'per_page': perPage,
            },
        });
    }

    /**
     * List Positions
     * List all Positions within your account.
     * @param xAccessToken
     * @param brandId Brand ID to filter positions by
     * @returns any OK
     * @throws ApiError
     */
    public static getInternalApiWxPositions(
        xAccessToken: string,
        brandId?: string,
    ): CancelablePromise<{
        positions?: Array<{
            /**
             * Unique identifier for the account
             */
            account_id: string;
            /**
             * Unique identifier for the position
             */
            id: string;
            /**
             * The name of the position
             */
            name: string;
            /**
             * Short description of position
             */
            short_description?: string | null;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/positions',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

}